module.exports = __webpack_public_path__ + "img/xinxqu.2de63d95.png";